// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import Sidebar from "./Components/AllComponents/Sidebar";
// import Home from "./Components/Pages/Home";
// import reportWebVitals from "./reportWebVitals";
// import "bootstrap/dist/css/bootstrap.min.css";
// import AppointmentForm from "./Components/AllComponents/Apoinment";
// import UserInfo from "./Components/AllComponents/UserInfo";
// import {
//   createBrowserRouter,
//   createRoutesFromElements,
//   Route,
//   RouterProvider,
// } from "react-router-dom";
// import RegistrationForm from "./Components/AllComponents/Registration";
// import Searchbar from "./Components/AllComponents/Searchbar";
// import AuthPage from "./Components/Credentials/AuthPage";
// import { ToastContainer } from "react-toastify";


// const router = createBrowserRouter(
//   createRoutesFromElements(
//     <>
//       {/* Login route - outside sidebar layout */}
//       <Route path="/" element={<AuthPage />} />

//       {/* Routes with sidebar layout */}
//       <Route path="/app" element={<Sidebar />}>
//         <Route index element={<Home />} />
//         <Route path="dashboard" element={<AppointmentForm />} />
//         <Route path="patient" element={<Searchbar />} />
//         <Route path="comment" element={<RegistrationForm />} />
//         <Route path="analytics" element={<AppointmentForm />} />
//         <Route path="product" element={<RegistrationForm />} />
//         <Route path="productList" element={<AppointmentForm />} />
//         <Route path="patient/user-info/:id" element={<UserInfo />} />
//       </Route>

//     </>
//   )
// );


// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <RouterProvider router={router} />
//     <ToastContainer position="top-right" autoClose={3000} />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Sidebar from "./Components/AllComponents/Sidebar";
import Home from "./Components/Pages/Home";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import AppointmentForm from "./Components/AllComponents/Apoinment";
import UserInfo from "./Components/AllComponents/UserInfo";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Outlet,
} from "react-router-dom";
import RegistrationForm from "./Components/AllComponents/Registration";
import Searchbar from "./Components/AllComponents/Searchbar";
import AuthPage from "./Components/Credentials/AuthPage";
import ProtectedRoute from "./Components/Credentials/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import Medicine from "./Components/Pages/Medicine";
import Treatments from "./Components/Pages/Treatments";
import Requests from "./Components/Pages/Requests";
import AdminDashboard from "./Components/Pages/AdminDashboard";
import FollowUpPatients from "./Components/Pages/FollowUpPatients";
import Campaign from "./Components/Pages/Campaign";
import SalesFollowUp from "./Components/Pages/SalesFollowUp";
import SalesDailyReport from "./Components/Pages/SalesDailyReport";
import CampDailyReports from "./Components/Pages/CampDailyReports";
import Branches from "./Components/Pages/Branches";
import { initTheme } from "./theme/theme";
import "./theme/dark.css";

initTheme();
console.log("Medicine value:", Medicine);
console.log("Treatments value:", Treatments);

console.log("Router routes loaded:", [
  "/",
  "/app",
  "/app/medicine",
  "/app/treatments",
]);

const RootLayout = () => (
  <>
    <ToastContainer position="top-right" autoClose={3000} />
    <Outlet />
  </>
);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      {/* Login route - outside sidebar layout */}
      <Route path="/" element={<AuthPage />} />

      {/* Routes with sidebar layout - PROTECTED */}
      <Route path="/app" element={<ProtectedRoute />}>
        <Route element={<Sidebar />}>
          <Route index element={<Home />} />
          <Route path="dashboard" element={<AppointmentForm />} />
          <Route path="patient" element={<Searchbar />} />
          <Route path="comment" element={<RegistrationForm />} />
          <Route path="analytics" element={<AppointmentForm />} />
          <Route path="product" element={<RegistrationForm />} />
          <Route path="productList" element={<AppointmentForm />} />
          <Route path="patient/user-info/:id" element={<UserInfo />} />


          <Route path="admin-dashboard" element={<AdminDashboard />} />
          <Route path="follow-up" element={<FollowUpPatients />} />
          <Route path="medicine" element={<Medicine />} />
          <Route path="treatments" element={<Treatments />} />
          <Route path="requests" element={<Requests />} />
          <Route path="campaign" element={<Campaign />} />
          <Route path="sales-follow-ups" element={<SalesFollowUp />} />
          <Route path="sales-daily-report" element={<SalesDailyReport />} />
          <Route path="camp-daily-reports" element={<CampDailyReports />} />
          <Route path="branches" element={<Branches />} />
        </Route>
      </Route>
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();